<!-- 供应商申请记录 -->
<template>
  <div class="backgroundGrey">
    <template v-if="appList.length">
      <div class="details-card" v-for="(item,index) in appList" :key="index">
        <div class="details-title">
          {{ item.applyNo }}
          <span style="float:right;">{{ subStatus(item.applyStatus) }}</span>
        </div>
        <div class="detailsItem" @click="openDetails(item)">
          <div>
            <span>航班日期：</span>
            <span>{{ item.flightDate }}</span>
          </div>
          <div>
            <span>航线环：</span>
            <span>{{ item.flightNoRing }}</span>
          </div>
          <div>
            <span>航段环：</span>
            <span>{{ item.flightLineRing }}</span>
          </div>
          <div>
            <span>申请数量：</span>
            <span>{{ item.quantity }}</span>
          </div>
          <div>
            <span>可供数量：</span>
            <span>{{ item.realQuantity }}</span>
          </div>
        </div>
      </div>
    </template>
    <EmptyTips :tipsList="['暂无数据']" v-else />
  </div>
</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'

export default {
  components: {
    EmptyTips,
  },
  data() {
    return {
      tabList: [
        { name: '全部', id: -1 },
        { name: '待审批', id: 2 },
        { name: '待保障', id: 3 },
        { name: '已通过', id: 5 },
        { name: '已驳回', id: 4 },
        { name: '已失效', id: 6 },
      ],
      status: '-1',
      appList: [],
    }
  },
  activated() {
    this.getAddMatterApplyListBySupplier()
  },
  methods: {
    openDetails(item) {
      this.$utils.routerPush({
        name: 'ApplicationRecordSupplyDetails',
        query: {
          flightDate: item.flightDate,
          flightNoRing: item.flightNoRing,
          flightLineRing: item.flightLineRing,
          id: item.id,
        },
      })
    },
    // 机组获取加配单据列表
    getAddMatterApplyListBySupplier() {
      let url = '/api-sys/sell/addMatterSearch/getAddMatterApplyListBySupplier'
      let params = {
        supplierId: this.$store.state.userInfo.vonderId,
        companyId: this.$store.state.userInfo.companyId,
        status: -1 /*全部:-1,待审批:2,待保障:3,驳回申请人:4,完成:5,失效:6*/,
        pageNum: 1,
        pageSize: 10000,
      }
      this.$api.post(url, params).then((res) => {
        this.appList = res.data.list
      })
    },
    subStatus(status) {
      return this.tabList.filter((i) => i.id === status)[0] ? this.tabList.filter((i) => i.id === status)[0].name : ''
    },
  },
}
</script>

<style lang="less" scoped>
.bom-btn {
  border-top: 1px solid #ededed;
  padding: 10px 0;
  overflow: hidden;
}
.empty-tips {
  height: calc(100vh - 200px) !important;
}
</style>


// WEBPACK FOOTER //
// src/view/ApplicationRecord/ApplicationRecordSupply.vue